import { createAction } from 'redux-actions'

const NAMESPACE = 'CHAT::'

export const openChat = createAction(NAMESPACE + 'OPEN')
export const toggleIsOpen = createAction(NAMESPACE + 'TOGGLE')
